export * from './urls/parentURLs';
export * from './urls/childURLs';
export * from './urls/dialogURLKeys';

export const MENU_URL = "/menu";